import React from 'react';
import { Link, useNavigate } // Tambahkan useNavigate
from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Layout.css'; // Asumsi Anda punya file CSS ini

function Header() {
  const auth = useAuth();
  const navigate = useNavigate(); // Gunakan hook useNavigate

  const handleLogout = async () => {
    await auth.logout();
    navigate('/login'); // Arahkan ke login setelah logout
  };

  return (
    <header className="app-header">
      <div className="header-title">
        <Link to="/dashboard">Ponus Admin Dashboard</Link>
      </div>
      <div className="header-user-info">
        <span>Selamat Datang, {auth.adminUser?.name || 'Admin'}!</span>
        <button onClick={handleLogout} className="logout-button-header">
          Logout
        </button>
      </div>
    </header>
  );
}

export default Header;